<div
  class="custom-select"
  [class.disabled]="isDisabled"
>
  <!--  An input field is used, since suppressKeyboardEvent does not work for selects, only for input fields-->
  <input
    class="selected-option ignore-focus"
    [class.error]="error"
    #selectElement
    (gridCustomFocus)="onGridCustomFocus($event)"
    (keydown)="onKeydown($event)"
    (click)="toggleDropdown()"
    (focusin)="onFocusIn($event)"
    [readonly]="true"
    [placeholder]="placeholder | translate"
    [value]="getSelectedOptionText()"
  />
  <i *ngIf="!isDisabled" class="select-icon xicon-arrow-down"></i>
  <i *ngIf="isDisabled" class="select-icon xicon-lock"></i>
  <ul
    *ngIf="isDropdownOpen"
    #selectBoxElement
    [class.top-position]="isPositionTop || autoPositionTop"
    class="dropdown-list"
    [style.max-height]="dropdownListMaxHeight"
  >
    <li *ngIf="searchable" class="dropdown-search-item" (click)="$event.stopPropagation()">
      <div class="dropdown-search-wrapper">
        <xux-icon icon="icon-search" class="dropdown-search-icon"></xux-icon>
        <input
          class="dropdown-search-input"
          type="text"
          [(ngModel)]="searchText"
          (ngModelChange)="onSearchChange()"
          [placeholder]="I18n.Common.Search | translate"
          (keydown)="onSearchInputKeydown($event)"
          autofocus
        />
      </div>
    </li>
    <ng-container *ngIf="searchable; else defaultOptions">
      <li
        *ngFor="let option of filteredOptions; let i = index"
        (click)="selectOption(option)"
        [class.selected]="option.value === value"
        [class.highlighted]="i === highlightedIndex"
      >
        {{ option.text | translate }}
      </li>
      <li *ngIf="filteredOptions.length === 0" class="dropdown-no-results">
        {{ I18n.Common.NoResultsFound | translate }}
      </li>
    </ng-container>
    <ng-template #defaultOptions>
      <li
        *ngFor="let option of options; let i = index"
        (click)="selectOption(option)"
        [class.selected]="option.value === value"
        [class.highlighted]="i === highlightedIndex"
      >
        {{ option.text | translate }}
      </li>
    </ng-template>
  </ul>
</div>
